exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._13CAwgO9DeKUD9emkVqPcn ._1GbEWnegqjXMsqCKfmAIDf{text-decoration:underline;cursor:pointer}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_13CAwgO9DeKUD9emkVqPcn",
	"goto-definition-link": "_1GbEWnegqjXMsqCKfmAIDf"
};